import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const FilterCheckIconGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M 5 12.21 L 0 7.21 L 1.41 5.8 L 5 9.38 L 12.59 1.79 L 14 3.21 L 5 12.21 Z"
        fill={fillColor}
      />
    </g>
  );
};

export const FilterCheckIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...(props.svg ?? {})}
    >
      <FilterCheckIconGroup {...props} />
    </svg>
  );
};
